import { Component, Input } from '@angular/core';

import { CaGroup } from '../../../core';

@Component({
    selector: 'cmps-ca-evaluation-result-phase-content',
    templateUrl: './phase-content.component.html',
})
export class PhaseContentComponent {
    @Input()
    group: CaGroup;
}
